import { createAction, props } from '@ngrx/store';

export const loadAgeDistributionChart = createAction(
  '[UserAnalytics] Load AgeDistributionChart',
  props<{ request: { BusinessId: string } }>()
);

export const loadAgeDistributionChartSuccess = createAction(
  '[UserAnalytics] Load AgeDistributionChart Success',
  props<{ response: any }>()
);

export const loadAgeDistributionChartFailure = createAction(
  '[UserAnalytics] Load AgeDistributionChart Failure',
  props<{ error: Error | any }>()
);

export const loadFundCreditByAgeChart = createAction(
  '[UserAnalytics] Load FundCreditByAgeChart',
  props<{ request: { BusinessId: string } }>()
);

export const loadFundCreditByAgeChartSuccess = createAction(
  '[UserAnalytics] Load FundCreditByAgeChart Success',
  props<{ response: any }>()
);

export const loadFundCreditByAgeChartFailure = createAction(
  '[UserAnalytics] Load FundCreditByAgeChart Failure',
  props<{ error: Error | any }>()
);

export const loadContributionsByAgeChart = createAction(
  '[UserAnalytics] Load ContributionsByAgeChart',
  props<{ request: { BusinessId: string } }>()
);

export const loadContributionsByAgeChartSuccess = createAction(
  '[UserAnalytics] Load ContributionsByAgeChart Success',
  props<{ response: any }>()
);

export const loadContributionsByAgeChartFailure = createAction(
  '[UserAnalytics] Load ContributionsByAgeChart Failure',
  props<{ error: Error | any }>()
);

export const loadFundingStatusDistributionChart = createAction(
  '[UserAnalytics] Load FundingStatusDistributionChart',
  props<{ request: { BusinessId: string } }>()
);

export const loadFundingStatusDistributionChartSuccess = createAction(
  '[UserAnalytics] Load FundingStatusDistributionChart Success',
  props<{ response: any }>()
);

export const loadFundingStatusDistributionChartFailure = createAction(
  '[UserAnalytics] Load FundingStatusDistributionChart Failure',
  props<{ error: Error | any }>()
);

export const loadFundingStatusByAgeBarChart = createAction(
  '[UserAnalytics] Load FundingStatusByAgeBarChart',
  props<{ request: { BusinessId: string } }>()
);

export const loadFundingStatusByAgeBarChartSuccess = createAction(
  '[UserAnalytics] Load FundingStatusByAgeBarChart Success',
  props<{ response: any }>()
);

export const loadFundingStatusByAgeBarChartFailure = createAction(
  '[UserAnalytics] Load FundingStatusByAgeBarChart Failure',
  props<{ error: Error | any }>()
);

export const loadFundingStatusByAgeScatterChart = createAction(
  '[UserAnalytics] Load FundingStatusByAgeScatterChart',
  props<{ request: { BusinessId: string } }>()
);

export const loadFundingStatusByAgeScatterChartSuccess = createAction(
  '[UserAnalytics] Load FundingStatusByAgeScatterChart Success',
  props<{ response: any }>()
);

export const loadFundingStatusByAgeScatterChartFailure = createAction(
  '[UserAnalytics] Load FundingStatusByAgeScatterChart Failure',
  props<{ error: Error | any }>()
);

export const loadRequiredIncreaseInContributionsBarChart = createAction(
  '[UserAnalytics] Load RequiredIncreaseInContributionsBarChart',
  props<{ request: { BusinessId: string } }>()
);

export const loadRequiredIncreaseInContributionsBarChartSuccess = createAction(
  '[UserAnalytics] Load RequiredIncreaseInContributionsBarChart Success',
  props<{ response: any }>()
);

export const loadRequiredIncreaseInContributionsBarChartFailure = createAction(
  '[UserAnalytics] Load RequiredIncreaseInContributionsBarChart Failure',
  props<{ error: Error | any }>()
);

export const loadRequiredIncreaseInContributionsScatterChart = createAction(
  '[UserAnalytics] Load RequiredIncreaseInContributionsScatterChart',
  props<{ request: { BusinessId: string } }>()
);

export const loadRequiredIncreaseInContributionsScatterChartSuccess = createAction(
  '[UserAnalytics] Load RequiredIncreaseInContributionsScatterChart Success',
  props<{ response: any }>()
);

export const loadRequiredIncreaseInContributionsScatterChartFailure = createAction(
  '[UserAnalytics] Load RequiredIncreaseInContributionsScatterChart Failure',
  props<{ error: Error | any }>()
);
